import { render, staticRenderFns } from "./ItemLista.vue?vue&type=template&id=bdf78034&scoped=true"
import script from "./ItemLista.vue?vue&type=script&lang=js"
export * from "./ItemLista.vue?vue&type=script&lang=js"
import style0 from "./ItemLista.vue?vue&type=style&index=0&id=bdf78034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf78034",
  null
  
)

export default component.exports